export default "/images/vendor/flag-icon-css/flags/1x1/vu.svg?87d69c1826cf7245c2d83ae1d4e4a7fb";